import { Box, Typography, styled } from "@mui/material";

export const Sticky = styled("div", {
	shouldForwardProp: (prop) => prop !== "imageUrl"
})<{
	imageUrl: string;
}>`
	font-size: clamp(9px, 1.52vw, 15px);
	position: relative;
	margin-left: 10%;
	background-repeat: no-repeat;
	background-position: center center;
	background-size: cover;
	height: 8.9333em;
	width: 30.7333em;
	flex: 0 0 auto;
	transform: translateX(-10%);
	background-image: url(${(props) => props.imageUrl});
	cursor: pointer;
	pointer-events: auto;

	> div {
		width: inherit;
		height: inherit;
	}

	@media (min-width: 721px) {
		margin-left: 0;
		width: 32.3333em;
		height: 5.9333em;
		transform: none;
	}
`;

export const Text = styled(Typography)`
	position: absolute;
	left: 30%;
	top: 35%;
	font-family: "Baloo";
	font-size: 1.0666em;
	color: white;
	text-shadow: 0px 1.05px 0px #000;
	-webkit-text-stroke-width: 0.7;
	-webkit-text-stroke-color: #000;

	@media (min-width: 721px) {
		left: 20%;
		top: 26%;
	}
`;

export const Button = styled("button")`
	position: absolute;
	top: 20%;
	transform: translateY(-50%);
	right: 5%;
	background-color: unset;
	border: unset;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 2em;
	height: 2em;
	border-radius: 100%;

	svg {
		font-size: inherit;
		stroke: #fff;
		width: 2em;
		height: 2em;
	}

	@media (max-width: 721px) {
		top: 30%;
	}
`;

export const EmptyProgressBar = styled(Box)`
	position: absolute;
	left: 30%;
	top: 70%;
	transform: translateY(-50%);
	width: 55%;
	height: 18px;
	padding: 0.1066em;
	border: 0.1333em solid #fff;
	border-radius: 1.0666em;
	background-color: rgba(255, 255, 255, 0.2);

	@media (min-width: 721px) {
		top: 65%;
		left: 20%;
		width: 65%;
	}
`;

export const Bar = styled(Box)`
	position: relative;
	width: 100%;
	height: 100%;
	border-radius: 1.0666em;
	display: flex;
	align-items: center;
`;

export const FillPercentage = styled(Box)`
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	display: flex;
	justify-content: flex-end;
	border-radius: 1.0666em;
	transition: all 0.3s ease;
	min-width: 10%;
	background: linear-gradient(
		180deg,
		#ffe37e 0%,
		#ffe178 19.09%,
		#ffda58 20.5%,
		#ffc700 100%
	);
`;

export const FillText = styled("div")`
	display: flex;
	position: absolute;
	align-items: center;
	color: #333333;
	left: 4%;
	font-family: "Inter";
	font-size: 1em;
	font-weight: 700;
	line-height: 1;

	p {
		margin: 0;
	}

	a {
		text-decoration: none;
		color: #333333;
		width: max-content;
	}

	svg {
		margin-right: 0.2666em;
		width: 1.2em;
		height: 1.0666em;
	}
`;

/* export const RewardsCountDot = styled("div")`
	position: absolute;
	top: -50%;
	right: 5px;
	font-family: "Inter";
	font-size: 12px;
	font-weight: 700;
	background-color: #e53939;
	border-radius: 50%;
	width: 15px;
	height: 15px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	z-index: 1;
`; */
